<template>
  <div :class="['configurator-preselector_step form-field', { [order]: order, isSelected: selected }]">
    <v-select
      class="preselector "
      v-model="selected"
      label="name"
      :loading="isLoading"
      :options="[...priorityOptions, ...options]"
      :clearable="false"
      :placeholder="title"
      :select-on-key-codes="[9, 13]"
      :selectable="isItemSelectable"
      :filter-by="filterOutPriority"
      :disabled="!isActive"
    >
      <template #no-options>
        Keine Optionen wählbar.
      </template>
      <template #option="item">
        <span>{{ item.name }}</span>
      </template>
    </v-select>
  </div>
</template>
<script>
import Vue from 'vue';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Flow } from "../services/flow";
import OpenIndicator from "./helpers/OpenIndicator.vue";

vSelect.props.components.default = () => ({
  OpenIndicator
});
Vue.component(vSelect);

export default {
  name: "Preselector",
  props: ["name", "title", "priority", "order"],
  components: {
    vSelect
  },
  computed: {
    selected: {
      get() {
        return [...this.priorityOptions, ...this.options].find((item) => {
          
          const idToCheck = String(item.id).includes('priority-') ? item.id.replace("priority-", "") : item.id;
          return idToCheck === this.$store.state.selected[this.name]
        }
        );
      },
      set(value) {
        this.$store.dispatch("selectOption", {
          name: this.name,
          value: value.hasOwnProperty("priority")
            ? value.id.replace("priority-", "")
            : value.id
        });
      }
    },
    id: function() {
      return "step-" + this.name;
    },
    isLoading: function() {
      return !this.isInactive && this.$store.state.options[this.name] == null;
    },
    options: function() {
      return this.$store.state.options[this.name] != null
        ? this.$store.state.options[this.name]
        : [];
    },
    isInactive: function() {
      return this.isActive == false;
    },
    isActive: function() {
      return Flow.isActiveStep(this.$store, this.name);
    },
    priorityArray: function() {
      return this.priority.split(",");
    },
    priorityOptions: function() {
      if (this.priority && this.options) {
        let priotityMap = this.options
          .filter(element => this.priorityArray.indexOf(element.name) >= 0)
          .map(item => ({
            ...item,
            id: "priority-" + item.id,
            priority: true
          }));
        priotityMap.push({
          name: '',
          separator: true,
          id: 23232323232
        })
        return priotityMap;
      } else {
        return [];
      }
    }
  },
  methods: {
    isItemSelectable(item) {
      if (item.hasOwnProperty('separator')) {
        return false
      } else {
        return true
      }
    },
    filterOutPriority: (option, label, search) => {
      let temp = search.toLowerCase();
      return typeof option.name === 'string' && option.name.toLowerCase().indexOf(temp) > -1 && !option.hasOwnProperty('priority');
    }
  }
};
</script>
<style lang="scss">
.preselector {
  .vs__search,
  .vs__selected {
    font-size: 18px !important;
    line-height:24px !important;
    padding-left:50px !important;
    font-weight: 700;
  }
}

.preselector-step {
  &.configurator-preselector_step.first .vs__selected-options:before { content: "\f0a4"; }
  &.configurator-preselector_step.second .vs__selected-options:before { content: "\f1b9"; }
  &.configurator-preselector_step.third .vs__selected-options:before { content: "\f073"; }
  &.configurator-preselector_step {
    .vs__selected-options {
      &::before {
        content: "\f0a4";
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        display: inline-block;
        color: #c4232a;
        font-size: 18px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 15px;
        z-index:10;
        
        @media (min-width: 1520px) {
          left: 20px;
        }
      }
    }
    &.isSelected {
      .vs__selected-options:before {
        content: '\f00c';
        color: #0EB77C;
      }
    }
  }

  .vs--disabled {
    .vs__selected-options {
      &:before {
        opacity:.3;
      }      
    }
    .vs__actions {
        opacity:.3;
      }
  }
}
.vs__dropdown-option--disabled {
  background: rgba(60,60,60,0.1);
  margin:5px auto;
}
.vs--disabled .vs__clear, .vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__open-indicator, .vs--disabled .vs__search, .vs--disabled .vs__selected {
  background-color: #f7f7f7;
  color:#999;
  margin-top:0;
}
</style>



// WEBPACK FOOTER //
// src/local-components/PreselectorStep.vue